import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import { DepartmentProvider } from './context/DepartmentContext'
import { ToastProvider } from './context/ToastContext'
import { ThemeProvider } from './context/ThemeContext'
import { AuthProvider } from './context/AuthContext'
import { syncFromFirestore } from './lib/store'
import { auth } from './lib/firebase'
import { onAuthStateChanged } from 'firebase/auth'
import './index.css'

// ─── Sentry initialisation (must be first) ───
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.2,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
  })
}

// Expose test function for Sentry verification
if (typeof window !== 'undefined') {
  window.testSentry = () => { throw new Error('Sentry test from Desres Kitchen') }
}

// Sync Firestore → localStorage only after user is authenticated
onAuthStateChanged(auth, (user) => {
  if (user) syncFromFirestore()
})

const SentryFallback = () => (
  <div style={{ padding: 32, textAlign: 'center', fontFamily: 'sans-serif' }}>
    <h2>Something went wrong</h2>
    <p>The error has been reported. Please refresh the page.</p>
    <button onClick={() => window.location.reload()} style={{ marginTop: 16, padding: '8px 24px', cursor: 'pointer' }}>
      Refresh
    </button>
  </div>
)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={SentryFallback}>
      <BrowserRouter>
        <ThemeProvider>
          <ToastProvider>
            <AuthProvider>
              <DepartmentProvider>
                <App />
              </DepartmentProvider>
            </AuthProvider>
          </ToastProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)
